import { t } from 'i18next'

import { InvoiceSearchDownloadState } from '@/components/features/invoice/InvoiceSearch/InvoiceSearchDownload/type'
import { InputOption } from '@/types'

export const INVOICE_TITLE = t('invoice.title')
export const INVOICE_FILE_PREVIEW_DIALOG_TITLE = t('invoice.preview.title')
export const INVOICE_FILE_BULK_DIALOG_TITLE = t('invoice.file.bulk')
export const INVOICE_FILE_HISTORY_DIALOG_TITLE = t('invoice.file.history')
export const INVOICE_RECEIPT_LIST_DIALOG_TITLE = t('receipt.list.title')
export const INVOICE_FILTER_DIALOG_TITLE = t('invoice.search.title')
export const INVOICE_PDF_DUMMY_SRC = 'http://localhost:3000/pdf/default.pdf'
export const INVOICE_PDF_DOWNLOAD_STATUS = {
  downloaded: t('invoice.file.status.downloaded'),
  notDownloaded: t('invoice.file.status.notDownloaded'),
  mailed: t('invoice.file.status.mailed'),
  invalid: t('invoice.file.status.invalid'),
  noInvoice: t('invoice.file.status.noInvoice'),
}
export const INVOICE_SEARCH_DOWNLOAD_STATUS: InputOption<InvoiceSearchDownloadState>[] =
  [
    { label: t('invoice.search.status.all'), value: 'all' },
    { label: t('invoice.search.status.notDownloaded'), value: 'notDownloaded' },
    {
      label: t('invoice.search.status.downloadedAndMailed'),
      value: 'downloadedAndMailed',
    },
  ]

export const INVOICE_NOT_FOUND = t('invoice.notFound.common')
export const INVOICE_NOT_FOUND_IN_FILTER = t('invoice.notFound.filter')
export const INVOICE_HISTORY_NOT_FOUND = t('invoice.notFound.history')
export const INVOICE_PREVIEW_NOT_FOUND = t('invoice.notFound.preview')
